import { getCurrentUserSession } from 'providers/auth'
import { addEndpoint, addQueryParams } from 'utils/api'

export const API_URL = process.env.REACT_APP_VIDEO_API as string

export const authorizedRequest = async ({
  endpoint,
  method,
  body,
  params,
}: {
  endpoint: string
  method: 'GET' | 'POST' | 'PUT' | 'PATCH'
  body?: object
  params?: { [key: string]: string | undefined }
}) => {
  try {
    const url = new URL(API_URL)
    addEndpoint(url, endpoint)
    params && addQueryParams(url, params)

    const { session } = await getCurrentUserSession()
    if (!session) {
      throw Error('Current user session not found')
    }
    const idToken = session.getIdToken().getJwtToken()

    // const idToken = "eyJraWQiOiJGYmw3THNsNWNWTnk4cHJqSUdRYnlwam16TWVyTjdkZTE5ak9oUU5FSlwvVT0iLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiIyYTc4MGE0Zi1jNDdjLTQxYmMtOGU0Yy03YTY3MmY0NWE5MDMiLCJjb2duaXRvOmdyb3VwcyI6WyJTdXBwb3J0R3JvdXAiLCJUZWFjaGVyVXNlckdyb3VwIiwiVGVhY2hlckFkbWluR3JvdXAiXSwiZW1haWxfdmVyaWZpZWQiOnRydWUsImlzcyI6Imh0dHBzOlwvXC9jb2duaXRvLWlkcC5ldS13ZXN0LTEuYW1hem9uYXdzLmNvbVwvZXUtd2VzdC0xX0lrSkNkUHhTaCIsImNvZ25pdG86dXNlcm5hbWUiOiIyYTc4MGE0Zi1jNDdjLTQxYmMtOGU0Yy03YTY3MmY0NWE5MDMiLCJhdWQiOiJ0bjM3Y2txbDhtc3Fxa3RobmppcjA5OGIwIiwiZXZlbnRfaWQiOiIzNTRiZjJhOC01MTRhLTRjMTMtYjQxNy0yYjYwZmNkMTc2NDYiLCJ0b2tlbl91c2UiOiJpZCIsImF1dGhfdGltZSI6MTY1NDY0ODk2MiwiZXhwIjoxNjYyNTY2MzE0LCJpYXQiOjE2NjI0Nzk5MTQsImVtYWlsIjoic2FtLmNyZXdlLXN1bGxhbUBtYWhhcmlzaGkuZm91bmRhdGlvbiJ9.OZqZmo_l-t8vVpv3Wxd-Vuc7cCGzBWyje10t8qIMsiZBz93fjqVZVLPLZsOszjTzDFgLYJaBBM2BkDH-a-C2wS-NnAsQgIAXhboZUMmLSMxRSYYUN96f58iRS8vsp6_HSemSxYQPqkOXlmmC3QYO4RAMJHhmuwU_jt8J0ogODNVYFUiYZsj0XcB6sU49a5WeOqpsGjY3i5wd4kNSWlGMk7_0XOVKmBom9u4IqnhxdI-mjz30_GIb_UJamJHPdEQW3G63IawDqf8uEMwGtJSYhOcjJ8mbqGCbHwNFwvxgHSWSP0HDGBpYuLvrZwrWNXdp6fJ7_MZUD1-w5vtVR0hEKA"
    const response = await fetch(url.toString(), {
      method: method,
      headers: {
        Authorization: `${idToken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })

    if (response.ok) {
      return response
    } else {
      const { error, message } = await response.json()
      throw Error(error ?? message)
    }
  } catch (e: any) {
    if (e.message === 'Failed to fetch')
      throw Error(
        'Please check your Internet connection and load the page again'
      )
    else throw e
  }
}
